import Component from './serial_code_management.vue'
export default Component
